import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useUpdateSyncLocations = () => {
  return useMutation({
    mutationFn: updateSyncLocations,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.viewLocationsByGroups.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locationListing.invalidateAll());
      queryClient.invalidateQueries(queryKeys.viewLocations.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.getLocationGroupsWithLocationCount.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.locationTags.invalidateAll());
      queryClient.invalidateQueries(queryKeys.locations.invalidateAll());
    },
  });
};

const updateSyncLocations = async () => {
  const data = await requestCCApi({
    url: '/hqLocations',
    method: 'POST',
    data: {
      action: 'sync',
    },
  });

  const { ids, deletedIds, updatedIds } = data as {
    ids: string[];
    deletedIds: string[];
    updatedIds: string[];
  };

  const numberOfAddedLocations = ids?.length || 0;
  const numberOfDeletedLocations = deletedIds?.length || 0;
  const numberOfUpdatedLocations = updatedIds?.length || 0;

  return Promise.resolve({
    numberOfAddedLocations,
    numberOfDeletedLocations,
    numberOfUpdatedLocations,
  });
};
